import { useEffect } from "react";

export function cleanupRecaptcha() {
    document
      .querySelectorAll<HTMLScriptElement>('script[src*="recaptcha"]')
      .forEach(el => el.remove());
  
    document
      .querySelectorAll<HTMLElement>('.grecaptcha-badge, iframe[src*="recaptcha"]')
      .forEach(el => el.remove());
  
    document
      .querySelectorAll<HTMLStyleElement>('style')
      .forEach(style => {
        if (style.innerHTML.includes('.grecaptcha-badge')) {
          style.remove();
        }
      });
  
    if (window.grecaptcha) {
      delete window.grecaptcha;
    }
    if ((window as any).___grecaptcha_cfg) {
      delete (window as any).___grecaptcha_cfg;
    }
  }

export function useRecaptcha(siteKey: string, active: boolean = true) {
  useEffect(() => {
    if (!siteKey || !active) return;

    if (document.querySelector(`script[src*="${siteKey}"]`)) return;

    const script = document.createElement("script");
    script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    return () => {
      cleanupRecaptcha();
    };
  }, [siteKey, active]);
}
